import { User } from 'firebase/auth';
import { collection, doc, getDocs, query, setDoc, where } from 'firebase/firestore/lite';

import EnrollmentData from '../types/enrollmentData';
import SkillData from '../types/skillData';
import { firestore } from '../utils/firebase';

export type NewEnrollmentData = Omit<EnrollmentData, 'id'>;

export default class EnrollmentApi {
  private static readonly collectionReference = collection(firestore, 'enrollments');

  static async getEnrollmentByUserAndSkill(user: User, skill: SkillData): Promise<EnrollmentData | undefined> {
    const querySnaps = await getDocs(
      query(this.collectionReference, where('userUuid', '==', user.uid), where('skillId', '==', skill.id))
    );

    const docSnap = querySnaps.docs.pop();
    if (!docSnap) return undefined;
    return { ...docSnap.data(), id: docSnap.id } as EnrollmentData;
  }

  static async getEnrollmentsByUser(user: User): Promise<EnrollmentData[]> {
    const querySnaps = await getDocs(query(this.collectionReference, where('userUuid', '==', user.uid)));
    return querySnaps.docs.map(docSnap => {
      return { ...docSnap.data(), id: docSnap.id } as EnrollmentData;
    });
  }

  static async getEnrollmentsByModule(skill: SkillData): Promise<EnrollmentData[]> {
    const querySnaps = await getDocs(query(this.collectionReference, where('skillId', '==', skill.id)));
    return querySnaps.docs.map(docSnap => {
      return { ...docSnap.data(), id: docSnap.id } as EnrollmentData;
    });
  }

  static async addEnrollment(enrollment: NewEnrollmentData): Promise<string> {
    const docRef = doc(this.collectionReference);
    await setDoc(docRef, { ...enrollment, id: docRef.id });
    return docRef.id;
  }
}
